import { PageHero, CtaSection } from '../../components'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import './Privacy.css'

const BREADCRUMBS = [
  { label: 'Trang chủ', path: '/' },
  { label: 'Chính sách bảo mật' },
]

const PrivacyPage = () => {
  useDocumentTitle('Chính Sách Bảo Mật - MAXCONST')

  return (
    <div className="privacy-page">
      {/* Page Hero */}
      <PageHero
        tag="Quy định chính sách"
        title="CHÍNH SÁCH BẢO MẬT THÔNG TIN"
        titleHighlight="BẢO MẬT"
        description="MAXCONST cam kết bảo mật tuyệt đối mọi thông tin cá nhân mà quý khách hàng tin tưởng cung cấp."
        breadcrumbs={BREADCRUMBS}
      />

      <div className="container privacy-container">
        <div className="privacy-card">
          {/* Tóm tắt nội dung */}
          <div className="privacy-intro-summary">
            <h3>Tóm tắt nội dung chính sách</h3>
            <ol className="summary-list">
              <li><a href="#muc-1">1. Mục đích và phạm vi thu thập thông tin</a></li>
              <li><a href="#muc-2">2. Phạm vi sử dụng thông tin</a></li>
              <li><a href="#muc-3">3. Thời gian lưu trữ thông tin</a></li>
              <li><a href="#muc-4">4. Cam kết bảo mật thông tin cá nhân khách hàng</a></li>
            </ol>
            <p className="summary-text-highlight">
              <strong>MAXCONST</strong> cam kết bảo mật tuyệt đối mọi thông tin cá nhân mà quý khách cung cấp. Chúng tôi không bán, chia sẻ hay trao đổi dữ liệu của khách hàng cho bất kỳ bên thứ ba nào khi chưa có sự đồng ý của quý khách.
            </p>
          </div>

          {/* Mục 1 */}
          <div className="privacy-section-detail" id="muc-1">
            <h2 className="section-title-custom">1. Mục đích và phạm vi thu thập thông tin</h2>
            
            <h4 className="sub-section-title">Mục đích thu thập</h4>
            <p>Chúng tôi chỉ thu thập những thông tin cần thiết phục vụ cho việc:</p>
            <ul className="custom-bullet-list">
              <li>Liên hệ tư vấn trực tiếp cho khách hàng.</li>
              <li>Trao đổi về tiến độ và phương án thiết kế – thi công.</li>
              <li>Cung cấp báo giá chi tiết và các giải pháp phù hợp với nhu cầu của khách hàng.</li>
            </ul>

            <h4 className="sub-section-title">Phạm vi thu thập thông tin</h4>
            <p>Các thông tin cần thu thập bao gồm:</p>
            <ul className="custom-bullet-list grid-list">
              <li>Họ và tên</li>
              <li>Số điện thoại</li>
              <li>Địa chỉ</li>
              <li>Loại dịch vụ cần tư vấn (Nhà vườn, nhà phố, biệt thự...)</li>
              <li>Yêu cầu cụ thể của công trình</li>
              <li>Các thông tin liên quan khác (nếu có)</li>
            </ul>
          </div>

          {/* Mục 2 */}
          <div className="privacy-section-detail" id="muc-2">
            <h2 className="section-title-custom">2. Phạm vi sử dụng thông tin</h2>
            <p>Thông tin khách hàng được <strong>MAXCONST</strong> sử dụng trong các trường hợp sau:</p>
            <ul className="custom-bullet-list">
              <li>Liên hệ và tư vấn trực tiếp cho khách hàng.</li>
              <li>Cung cấp thông tin chi tiết về sản phẩm, thiết kế và các gói dịch vụ xây dựng.</li>
              <li>Thông báo tiến độ, báo cáo tình trạng thi công thực tế tại công trình/dự án.</li>
              <li>Gửi tài liệu tham khảo, thông tin hữu ích hoặc chương trình ưu đãi mới nhất có liên quan đến khách hàng.</li>
            </ul>
          </div>

          {/* Mục 3 */}
          <div className="privacy-section-detail" id="muc-3">
            <h2 className="section-title-custom">3. Thời gian lưu trữ thông tin</h2>
            <p>
              Thông tin sẽ được lưu trữ trên hệ thống máy chủ của <strong>MAXCONST</strong> cho đến khi có yêu cầu hủy bỏ từ phía khách hàng hoặc khi <strong>MAXCONST</strong> không còn nhu cầu sử dụng cho mục đích cung cấp dịch vụ.
            </p>
          </div>

          {/* Mục 4 */}
          <div className="privacy-section-detail" id="muc-4">
            <h2 className="section-title-custom">4. Cam kết bảo mật thông tin cá nhân khách hàng</h2>
            <p><strong>MAXCONST</strong> cam kết:</p>
            <ul className="custom-bullet-list">
              <li>Bảo mật thông tin khách hàng an toàn tuyệt đối.</li>
              <li>Không chia sẻ dữ liệu cho bên thứ ba nếu không có sự đồng ý của khách hàng, trừ trường hợp cơ quan pháp luật có thẩm quyền yêu cầu.</li>
            </ul>

            <h4 className="sub-section-title">Các nguyên tắc bảo mật</h4>
            <p>Nhằm đảm bảo thông tin của khách hàng, chúng tôi quản lý và sử dụng thông tin của khách hàng dựa trên nguyên tắc bảo mật sau:</p>
            <ul className="custom-bullet-list">
              <li>Chỉ yêu cầu khách hàng cung cấp những thông tin cần thiết và có liên quan đến sản phẩm, bản vẽ thiết kế và dịch vụ thi công của <strong>MAXCONST</strong>.</li>
              <li>Sử dụng thông tin của khách hàng để tư vấn và đưa ra giải pháp thiết kế – thi công phù hợp và chất lượng nhất đến khách hàng.</li>
              <li>Tuyệt đối không tiết lộ thông tin của khách hàng cho bất kỳ ai nếu không có sự đồng ý của khách hàng hoặc pháp luật yêu cầu.</li>
              <li>Đảm bảo thông tin của khách hàng được lưu trữ chính xác và an toàn.</li>
              <li>Chỉ có những nhân sự có thẩm quyền trực tiếp mới được tiếp cận thông tin của khách hàng, kể cả nhân viên của <strong>MAXCONST</strong>.</li>
            </ul>

            <h4 className="sub-section-title">Bảo mật tài khoản liên hệ</h4>
            <p>
              Các hoạt động trao đổi, làm việc và duyệt phương án vẽ thiết kế với <strong>MAXCONST</strong> chủ yếu diễn ra qua nền tảng Zalo để nhanh chóng và thuận tiện nhất. Để đảm bảo an toàn, khách hàng cần:
            </p>
            <ul className="custom-bullet-list">
              <li>Giữ bí mật tuyệt đối tài khoản Zalo cá nhân của mình.</li>
              <li>Không chia sẻ thông tin tài khoản cho bất kỳ ai.</li>
              <li>Chủ động kiểm soát thiết bị đăng nhập và đổi mật khẩu khi cần thiết.</li>
            </ul>
            <p className="emphasis-text">
              <em>Việc bảo vệ thông tin là trách nhiệm và nghĩa vụ của cả <strong>MAXCONST</strong> lẫn khách hàng.</em>
            </p>

            <h4 className="sub-section-title">Điều khoản bổ sung</h4>
            <p>
              <strong>MAXCONST</strong> có quyền điều chỉnh, cập nhật nội dung trong chính sách bảo mật này mà không cần thông báo trước. Phiên bản chính sách mới nhất sẽ luôn được đăng tải công khai trên website chính thức của <strong>MAXCONST</strong>.
            </p>
          </div>

          {/* Footer liên hệ của chính sách */}
          <div className="privacy-footer-contact">
            <h3>Kết nối ngay đến chúng tôi để được hỗ trợ MIỄN PHÍ nhanh chóng nhất:</h3>
            <p className="company-name">MAXCONST – Đơn vị thiết kế & thi công uy tín (Thành viên MAXHOME Group)</p>
            <div className="contact-details-grid">
              <a href="tel:0979808278" className="contact-card-mini-link">
                <div className="contact-card-mini">
                  <i className="fas fa-phone-alt" />
                  <div>
                    <span>Hotline tư vấn:</span>
                    <strong>0979.808.278</strong>
                  </div>
                </div>
              </a>
              <a href="https://thietkethicongtrongoi.com" target="_blank" rel="noopener noreferrer" className="contact-card-mini-link">
                <div className="contact-card-mini">
                  <i className="fas fa-globe" />
                  <div>
                    <span>Website chính thức:</span>
                    <strong>thietkethicongtrongoi.com</strong>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <CtaSection
        title="Đồng Hành Cùng MAXCONST Xây Dựng Ngôi Nhà Mơ Ước"
        titleHighlight="Đồng Hành Cùng MAXCONST"
        description="Liên hệ ngay với đội ngũ kiến trúc sư và chuyên gia phong thủy của chúng tôi để nhận báo giá chi tiết và phương án thiết kế tối ưu."
      />
    </div>
  )
}

export default PrivacyPage
